import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Full-screen brand splash. Shows the hostbydims logo for ~1.4s
 * then fades out into the site. Rendered once at App root; unmounts
 * itself after the exit animation completes.
 */
export default function SplashScreen({ duration = 1400 }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(t);
  }, [duration]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="splash"
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="fixed inset-0 z-[100] bg-white flex items-center justify-center"
          style={{ pointerEvents: "none" }}
        >
          <motion.img
            src="/brand/hostbydims-logo.png"
            alt="hostbydims"
            data-testid="splash-logo"
            initial={{ scale: 0.94, opacity: 0, y: 8 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="w-64 max-w-[62%] object-contain select-none"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
